import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

const CallbackPage: React.FC = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthentication = () => {
      if (auth.isLoading) {
        // Still processing authentication, do nothing yet
        return;
      }

      if (auth.isAuthenticated) {
        navigate('/dashboard');
      } else if (auth.error) {
        console.error('Authentication error:', auth.error);
        navigate('/cadastro?error=auth_failed');
      }
    };

    handleAuthentication();
  }, [auth, navigate]);

  return (
    <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-blue-500 to-blue-600 p-5">
      <div className="max-w-md w-full text-center text-white bg-white/10 backdrop-blur-md rounded-xl p-10 shadow-2xl">
        <h2 className="mb-8 text-3xl font-bold">Processando Autenticação...</h2>
        <div className="w-16 h-16 border-4 border-white/30 border-t-white rounded-full animate-spin mx-auto mb-5"></div>
        <p className="text-lg">Por favor, aguarde enquanto validamos suas credenciais.</p>
      </div>
    </div>
  );
};

export default CallbackPage;